import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'SortAlphabetically' })
export class SortAlphabetically implements PipeTransform {
    transform(value: any, args: any[] = null): any {
        return [...value].sort((a, b) => {
            a = a.toLowerCase(); 
            b = b.toLowerCase(); 
            return a.localeCompare(b);
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/sort-alphabetically/sort-alphabetically.pipe.ts